export const base_path = "/";
export const image_path ='/';
export const base_url = "https://aeropackpos.in";
// export const base_url = "http://localhost:5001";


